// extracted by mini-css-extract-plugin
module.exports = {"root":"SketchBottomNavigation_root__1Rwpu","icon":"SketchBottomNavigation_icon__35Yj7"};